/* eslint-disable */
import { useState, useEffect, useCallback } from 'react';
import { axiosInstanceLive } from 'instance/Axios';
import { handleCatchError } from 'utils/CatchHandler';

function getEndpoint(role) {
    if (role === 'super-distributor') {
        return 'api/V2/moneytransfer/superDistributor/Urban/GetListMerchants';
    }
    return 'api/V2/moneytransfer/distributor/Urban/GetListMerchants';
}

export function useUrbanMerchants({ role, perPage: initialPerPage = 10 } = {}) {
    const [state, setState] = useState('loading');
    const [data, setData] = useState([]);
    const [totalCount, setTotalCount] = useState(0);
    const [pagination, setPagination] = useState({ currentPage: 1, lastPage: 1, from: 0, to: 0 });
    const [error, setError] = useState(null);

    const [status, setStatus] = useState('ALL');
    const [search, setSearch] = useState('');
    const [fromDate, setFromDate] = useState('');
    const [toDate, setToDate] = useState('');
    const [page, setPage] = useState(1);
    const [perPage, setPerPageState] = useState(initialPerPage);

    const fetchData = useCallback(async () => {
        setState('loading');
        setError(null);

        const token = localStorage.getItem('token');
        if (!token) {
            setState('error');
            setError({ category: 'session', message: 'Session unavailable. Please log in again.' });
            return;
        }

        const body = { status, per_page: perPage, page, start: (page - 1) * perPage };
        if (search) body.search = search;
        if (fromDate) body.fromdate = fromDate;
        if (toDate) body.todate = toDate;

        try {
            const response = await axiosInstanceLive.post(getEndpoint(role), body, {
                headers: { Authorization: `Bearer ${token}` }, timeout: 30000
            });

            const resData = response?.data;

            if (resData?.success && Array.isArray(resData.data) && resData.data.length > 0) {
                setData(resData.data);
                setTotalCount(resData.totalCount || resData.total || 0);
                setPagination({ currentPage: resData.current_page || 1, lastPage: resData.last_page || 1, from: resData.from || 1, to: resData.to || resData.data.length });
                setState('loaded');
            } else if (resData?.success) {
                setData([]);
                setTotalCount(0);
                setState('empty');
            } else {
                setState('error');
                setError({ category: 'server', message: resData?.message || 'Failed to load merchants.' });
            }
        } catch (err) {
            handleCatchError(err);
            setState('error');
            if (err.code === 'ECONNABORTED' || err.message?.includes('timeout')) {
                setError({ category: 'timeout', message: 'Request timed out. Please try again.' });
            } else if (err.message === 'Network Error' || !err.response) {
                setError({ category: 'network', message: 'Network unavailable. Check your connection.' });
            } else {
                setError({ category: 'server', message: 'Server error. Please try again later.' });
            }
        }
    }, [role, status, search, fromDate, toDate, page, perPage]);

    useEffect(() => { fetchData(); }, [fetchData]);

    return {
        state, data, totalCount, pagination, error,
        status, setStatus: (val) => { setStatus(val); setPage(1); },
        search, setSearch: (val) => { setSearch(val); setPage(1); },
        fromDate, setFromDate, toDate, setToDate,
        page, setPage,
        perPage, setPerPage: (val) => { setPerPageState(val); setPage(1); },
        retry: fetchData
    };
}

export default useUrbanMerchants;
